import Vue from 'vue/dist/vue.js'

export default Vue.extend({
  data() {
    return {
      image: null,
      tempImage: null,
    }
  },

  created() {
    this.set(this.params.value)
  },
  mounted() {
    Vue.nextTick(() => {
      this.$refs.container.focus()
    })
  },
  methods: {
    getValue() {
      return this.image
    },

    isPopup() {
      return true
    },

    set(img) {
      this.image = img
    },

    onClick(img) {},

    getTemp() {
      if (!this.tempImage) {
        return null
      }
      return URL.createObjectURL(this.tempImage)
    },

    onFileLoaded() {
      this.image = this.$refs.file_upload.files[0]
      this.tempImage = this.$refs.file_upload.files[0]
    },

    backdropClickHandler() {
      this.$refs.file_upload.click()
    },
  },
  template: `
        <div :ref="'container'" class="mood" tabindex="0">
            
        <div class="avatar-container">
        <div class="image-container">
          <img v-if="getTemp()" :src="getTemp()">
          <div v-else class="fallback">No Image</div>
        </div>
        <div class="backdrop" title="Upload photo" @click="backdropClickHandler">
          <span>+</span>
        </div>
        <input type="file" ref="file_upload" id="my_file" style="display: none;" @change="onFileLoaded">
      </div>
        </div>
    `,
})
